module.exports = __webpack_public_path__ + "img/openbadge-intro-3.9d1a5c59.png";